// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"263201de","419":"71f8a8e4","459":"94a3e028","643":"4378d566","684":"0aec77f0","734":"5e947551","774":"01553da6","883":"b829b18b"}[chunkId] + ".chunk.js";
};